module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-block"
  }, [_c('div', {
    staticClass: "graph-block__header"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.tip) ? _c('small', {
    staticClass: "graph-block__tip"
  }, [_vm._v("\n          *" + _vm._s(_vm.tip) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "graph-block__graph-container"
  }, [(_vm.yAxis) ? _c('div', {
    staticClass: "graph-block__y-title"
  }, [_vm._v("\n        " + _vm._s(_vm.yAxis) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.xAxis) ? _c('div', {
    staticClass: "graph-block__x-title"
  }, [_vm._v("\n        " + _vm._s(_vm.xAxis) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12b6947c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/layouts/ChartLayout.vue
// module id = 1819
// module chunks = 0